// PermissionRoute.jsx
import React from "react";
import { usePermissions } from "../hooks/usePermissions";
import NoPermission from "../pages/NoPermission";

const PermissionRoute = ({ permissionName, children }) => {
  const { hasPermission } = usePermissions();

  const hasRequiredPermission = hasPermission(permissionName);

  if (!hasRequiredPermission) {
    return <NoPermission />;
  }

  return <>{children}</>;
};

export default PermissionRoute;






// import PermissionRoute from "./PermissionRoute";

// <Route
//   path="/dashboard"
//   element={
//     <PermissionRoute permissionName="view-dashboard">
//       <Dashboard />
//     </PermissionRoute>
//   }
// />
